import {IPipeListFields} from '@/lib/types/common-types';
import DataLink from './DataLink';
import {titleize} from "@/lib/helper/inflector";
import languageCodeLookup from "@/lib/types/language-code-lookup"
import React from "react";
import useGenericRows, {titledPipeList} from "@/lib/hooks/useGenericRows"

export default function PipeList({fields}: { fields: IPipeListFields[] }) {

    const RenderedValue = (value) => {

        // console.log(value);

        if (typeof value === "object" && typeof value.value === "string") {
            return <span>{value.value}</span>
        }
        if (typeof value === "object" && Array.isArray(value.value)) {
            return <span>{value.value.join(",")}</span>
        }

        switch (typeof value) {
            case "object":
                if (Array.isArray(value)) {
                    return <span>{value.join(", ")}</span>
                }

                let rows = [];
                for (let[key, val] of Object.entries(value.value)) {

                    switch (typeof val) {
                        case "object":
                            let pipedValue = []
                            for(let [k, v] of Object.entries(val)) {
                                pipedValue.push(`<dt class="me-2">${k}</dt><dd>${v}</dd>`)
                            }
                            val = pipedValue.join("<span class='mx-2'>|</span>")
                            break;
                        default :
                            val = '<dd>' + val + '</dd>'
                            break;
                    }
                    rows.push({name: key, value: val});
                }

                return (
                    <>
                        {rows.map((item, i) => {
                            const markup = { __html: item.value };
                            return <div className="flex flex-row w-max" key={'hacklist' + i}>
                                <span className="me-2">{item.name}: </span>
                                <span className="flex flex-row flex-wrap" dangerouslySetInnerHTML={markup}></span>
                            </div>
                        })}
                    </>

                )

            default:
                return value;
        }
    }

    return (
        <dl className="pipelist subdata md:flex flex-wrap">
            {fields.map(({value, link, name}, i) => {

                name = name || "";
                if (name.startsWith("_")) {
                    name = name.substring(1, name.length);
                }
                if (!value && !link?.text) return null;


                switch (name) {
                    case "lang" : {
                        value = languageCodeLookup[value]?.name || value;
                    }
                }

                return (
                    <div key={"pipelist-" + i} className="flex mt-1" data-name={name}>
                        {/** Render <dt> & <dd> if name and value provided */}
                        {value && name && !link ? (
                            <div className="flex w-max">
                                <dt className="mr-1">{`${titleize(name)}: `}</dt>
                                <dd><RenderedValue value={value}></RenderedValue></dd>
                            </div>
                        ) : null}


                        {/** Render a (bold) span if just a value is provided */}
                        {!name && !link && value ? (
                            <strong>{value}</strong>
                        ) : null}

                        {/** Render a label (name) and link */}
                        {link && name && link.text ? (
                            <>
                                <dt className="mr-1">{`${titleize(name)}: `}</dt>
                                <dd>
                                    <DataLink link={link}/>
                                </dd>
                            </>
                        ) : null}

                        {/** Render a link, no name or value provided */}
                        {link && link.text && !name && !value ? (
                            <DataLink link={link}/>
                        ) : null}

                        {/** Add a pipe if there is a next item */}
                        {fields[i + 1] ? (
                            <div className="mx-2 hidden md:inline-block">|</div>
                        ) : null}
                    </div>
                );
            })}
        </dl>
    );
}
